/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = new Model({
	name: "managedbluetoothscanner",
	init: init,
	uninit: uninit,
	triggers: triggers,
	_group: null,
	track: track,
	untrack: untrack
});

function triggers(){
	return {
		"initialize": initialize,
		"reset": reset,

		"start:scan": start_scanning,
		"stop:scan": stop_scanning,
	};
}

function init() {
	this._who_tracker = this.dispatcher.createTracker();
	this._who = null;
	this.push([]);
}

function uninit() {
	this._who = null;
	this._who_tracker.off();
	this._who_tracker = null;
}

function initialize(data){
	this._who = data.who;
	this._group = data.group;
}

function start_scanning() {
	var who = this._who;
	var group = this._group;
	if(!who) return;
	if(group)
		this.emit("$mqtt:managegroup/" + group + "/patient/u/" + who + "/bluetooth/scan/start", {
			from: this.config.id
		});
	else
		this.emit("$mqtt:u/" + who + "/bluetooth/scan/start", {
			from: this.config.id
		});
	this.track();
	this.emit("usermetrics:trigger:track", "start bluetooth scan for managed user", {
		who: this._who,
	});
}

function stop_scanning() {
	var who = this._who;
	var group = this._group;
	if(!who) return;
	if(group)
		this.emit("$mqtt:managegroup/" + group + "/patient/u/" + who + "/bluetooth/scan/stop", {
			from: this.config.id
		});
	else
		this.emit("$mqtt:u/" + who + "/bluetooth/scan/stop", {
			from: this.config.id
		});
	this.emit("usermetrics:trigger:track", "stop bluetooth scan for managed user", {
		who: this._who,
	});
}

function track(){
	var who = this._who;
	var group = this._group;
	var tracker = this._who_tracker;

	tracker.off();
	if(group)
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/bluetooth/scan/scanned", handle_device_scanned.bind(this));
	else
		tracker.on("mqtt:u/" + who + "/bluetooth/scan/scanned", handle_device_scanned.bind(this));
}

function untrack(){
	var tracker = this._who_tracker;
	tracker.off();
}

function reset(){
	this._who = null;
	this.untrack();
}

function handle_device_scanned(device){
	this.dispatch("scanned", device);
}
